import {Pipe, PipeTransform} from '@angular/core';

import {DIAGRAM_VERSION_STATES_ENUM} from '../models/diagram-version.constant';

interface IChildDiagram {
  state: DIAGRAM_VERSION_STATES_ENUM;
  readyToAuthorise: boolean;
  hasAuthorisers: boolean;
}

@Pipe({
  name: 'getAuthorisableIcon',
  standalone: true
})
export class GetAuthorisableIconPipe implements PipeTransform {
  private authorisableIcon = 'approved';
  private notAuthorisableIcon = 'rejected';

  transform(diagram: IChildDiagram, isOverride: boolean): any {
    const {state, readyToAuthorise, hasAuthorisers} = diagram;
    const authorisable =
      state === DIAGRAM_VERSION_STATES_ENUM.DRAFT && readyToAuthorise && hasAuthorisers;

    switch (true) {
      case state === DIAGRAM_VERSION_STATES_ENUM.DRAFT && isOverride:
        return this.authorisableIcon;

      case state === DIAGRAM_VERSION_STATES_ENUM.BEING_AUTHORISED && isOverride:
        return this.notAuthorisableIcon;

      case authorisable:
        return this.authorisableIcon;

      default:
        return this.notAuthorisableIcon;
    }
  }
}
